import { TextToSubscribeDescriptionElement } from "@redotech/redo-content-builder-common/element-schema";
import { SUBSCRIBE_DESCRIPTION } from "@redotech/redo-marketing-common/signup-form/signup-form";
import { memo } from "react";
import { getBaseElementStyles } from "./base-element-styles";
import { ElementBox } from "./element-box";
import { FormElementProps } from "./index";

export const TextToSubscribeDescription = memo(
  function TextToSubscribeDescription({
    element,
  }: Pick<FormElementProps<TextToSubscribeDescriptionElement>, "element">) {
    const baseStyles = getBaseElementStyles(element);

    return (
      <ElementBox
        alignment={element.contentAlignment}
        alignsText
        // design-allow: merchant-authored text styles have no tokens
        style={{
          ...baseStyles,
          fontFamily: `'${element.fontFamily}'`,
          color: element.textColor,
          fontSize: "8px",
        }}
      >
        <span>{SUBSCRIBE_DESCRIPTION}</span>
      </ElementBox>
    );
  },
);
